import "./configurator.scss";
import React from "react";
import classNames from "classnames";

const Configurator = ({ logo, link, soon }) => {
  return (
    <div
      className={classNames(`configurator`, {
        [`configurator--soon`]: soon && soon[0] === "true",
      })}
    >
      <div
        className="configurator__logo"
        style={{
          backgroundImage: `url(${logo})`,
        }}
      />
      <div className="configurator__text">
        {soon && soon[0] === "true"
          ? "Konfigurator dostępny wkrótce!"
          : "Skonfiguruj swój pojazd i zamów go u nas!"}
      </div>
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className="configurator__btn"
      >
        Konfigurator{" "}
        <img src={require("assets/icons/configurator.png").default} alt="" />
      </a>
    </div>
  );
};

export default Configurator;
